import React from 'react'
import Lottie from "lottie-react";
import { useNavigate } from "react-router-dom";

const CustomLottie = ({animationData, text, width = "w-[30rem]"}) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col justify-center items-center">
      <div className= {width}>
        <Lottie animationData={animationData} />
      </div>
      <div
        className="text-[#130C40] text-3xl font-bold w-[25rem] text-center"
        style={{ fontFamily: "DM Sans" }}
      >
        {text}
      </div>
      <button
        onClick={() => navigate("/")}
        className="mt-4 text-[#130C40] text-lg font-medium underline hover:text-blue-600 transition-colors"
        style={{ fontFamily: "DM Sans" }}
      >
        Go to Home Page
      </button>
    </div>
  )
}

export default CustomLottie
